/**
 * cassation request variant constants and the request-type configuration overrides each variant implies.
 *
 * The variant is a three-state value: `null` means unresolved — the judgment that decides the variant has not
 * been read yet — and it is a first-class state, not a placeholder for a default. Neither variant component
 * renders while it is unresolved, and no variant-specific parent behavior applies.
 *
 * `CASSATION_VARIANT_CONFIG` is what the switcher hands up to `case-related-request/index.vue`, which merges it
 * blindly over the base `RequestTypes` entry without inspecting any key. The base entry keeps the New value
 * (`showRequestReasonSection: false`); Legacy's `true` is supplied here and only here, so the shared
 * `RequestTypes` object is never mutated.
 */

export const CASSATION_VARIANT = {
  legacy: 'legacy',
  new: 'new',
};

export const CASSATION_VARIANT_CONFIG = {
  [CASSATION_VARIANT.legacy]: { showRequestReasonSection: true },
  [CASSATION_VARIANT.new]: {},
};

/**
 * request-type configuration overrides for a resolved variant.
 * Unresolved (`null`) and any unrecognised value yield `{}` — the base configuration applies unchanged.
 *
 * @param {string|null} variant one of CASSATION_VARIANT, or null when unresolved
 * @returns {Object} overrides to merge over the base RequestTypes entry
 */
export function getCassationVariantConfig(variant) {
  return CASSATION_VARIANT_CONFIG[variant] || {};
}

export default CASSATION_VARIANT;
